import { Link, useRouter } from "../router";
import { useAuth } from "../auth";
import { BrandMark } from "../components/BrandMark";
import { QpCallRail } from "../components/QpCallRail";
import { qpRail, useQpRailOpen } from "../lib/qpRail";
import { Crm } from "../pages/Crm";
import { Portfolio } from "../pages/Portfolio";
import { Orders } from "../pages/Orders";
import { FlowChecks } from "../pages/FlowChecks";
import { Inbox } from "../pages/Inbox";
import { Webhooks } from "../pages/Webhooks";
import { Integrations } from "../pages/Integrations";
import { InvestorApp } from "../pages/InvestorApp";
import { QuantfolioEmbed } from "../pages/QuantfolioEmbed";
import { Advisory } from "../pages/Advisory";
import { Assistant } from "../pages/Assistant";
import { AgentDrawerHost } from "../pages/agent/AgentDrawer";

const sections = [
  { to: "/app/crm", label: "CRM" },
  { to: "/app/portfolio", label: "Portfolio" },
  { to: "/app/orders", label: "Orders" },
  { to: "/app/advisory", label: "Advisory" },
  { to: "/app/assistant", label: "Assistant" },
  { to: "/app/inbox", label: "Inbox" },
  { to: "/app/flow-checks", label: "Pre-order checks" },
  { to: "/app/webhooks", label: "Webhooks" },
  { to: "/app/integrations", label: "Integrations" },
  { to: "/app/investor-app", label: "Investor App" },
  { to: "/app/embedded-flow", label: "Embedded Flow" },
];

export function AppShell({ pathname }: { pathname: string }) {
  const { user, logout } = useAuth();
  const { navigate } = useRouter();
  const railOpen = useQpRailOpen();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  const sectionPath = sectionFor(pathname);

  return (
    <div className="shell">
      <header className="shell-topbar">
        <Link to="/app/crm" className="brand">
          <BrandMark />
          <span>Andersen</span>
        </Link>
        <div className="shell-user">
          <button
            onClick={() => qpRail.toggle()}
            className="btn btn-ghost btn-sm"
            type="button"
            title="Quantfolio API activity"
          >
            QP activity
          </button>
          <span className="shell-user-name">
            Signed in as <strong>{user?.username}</strong>
          </span>
          <button
            onClick={handleLogout}
            className="btn btn-ghost btn-sm"
            type="button"
          >
            Sign out
          </button>
        </div>
      </header>
      <div className={railOpen ? "shell-body rail-open" : "shell-body"}>
        <aside className="shell-sidebar">
          <nav className="shell-nav">
            {sections.map((s) => (
              <Link
                key={s.to}
                to={s.to}
                className={
                  sectionPath === s.to ? "shell-nav-link active" : "shell-nav-link"
                }
              >
                {s.label}
              </Link>
            ))}
          </nav>
          <div className="shell-sidebar-foot">
            <span className="label">Demo build</span>
            <span className="value">Andersen WM</span>
          </div>
        </aside>
        <main className="shell-main">
          <Section section={sectionPath} />
        </main>
        <QpCallRail />
      </div>
      <AgentDrawerHost pathname={pathname} />
    </div>
  );
}

function sectionFor(pathname: string): string {
  if (pathname === "/app" || pathname === "/app/") return "/app/crm";
  for (const s of sections) {
    if (pathname === s.to || pathname.startsWith(s.to + "/")) return s.to;
  }
  return "/app/crm";
}

function Section({ section }: { section: string }) {
  if (section === "/app/crm") return <Crm />;
  if (section === "/app/portfolio") return <Portfolio />;
  if (section === "/app/orders") return <Orders />;
  if (section === "/app/advisory") return <Advisory />;
  if (section === "/app/assistant") return <Assistant />;
  if (section === "/app/investor-app") return <InvestorApp />;
  if (section === "/app/embedded-flow") return <QuantfolioEmbed />;
  if (section === "/app/inbox") return <Inbox />;
  if (section === "/app/flow-checks") return <FlowChecks />;
  if (section === "/app/webhooks") return <Webhooks />;
  if (section === "/app/integrations") return <Integrations />;
  return <NotFound />;
}

function NotFound() {
  return (
    <div className="placeholder">
      <h1>Not found</h1>
      <p>This section doesn't exist yet.</p>
    </div>
  );
}
